export default __webpack_public_path__ + "static/media/problem-banner.5cae51e9.png";